export const isNumberLike = num => /^[0-9]+$/.test(num);
